export const SEARCH_PARAM_INDEX = "ix";
export const SEARCH_PARAM_CODE = "cd";
